import { c as _c } from "react/compiler-runtime";
import { Divider } from '@7f-ui/components/divider/divider';
import type { ReactNode } from 'react';
type DestinationsStatisticProps = {
  children: ReactNode;
};
export function DestinationsStatistic(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Divider alignment="vertical" className="h-4/5" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <div className="flex items-center gap-2">{t1}<div className="flex h-full flex-col justify-between">{children}</div></div>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}